import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router'
import { Add } from '@mui/icons-material'
import { useAppId } from 'src/app/AppProvider'
import { useTranslate } from 'src/i18n/useMessageSource'
import { NavigateState } from 'src/routing/Routing'
import { Permission } from 'src/service/backend/api'
import { ListingButton } from 'src/ui-shared/base/button/ListingButton'
import { ScreenLayout } from 'src/ui/layout/main-layout/ScreenLayout'
import { ManufacturerModelTable } from 'src/ui/page/wm/manufacturer-model/list/ManufacturerModelTable'
import { hasPermission } from 'src/user/RoleCheck'
import { useUser } from 'src/user/UserContext'

export const ManufacturerModelListPage = (): ReactElement => {
  const translate = useTranslate()

  const navigate = useNavigate()
  const appId = useAppId()
  const user = useUser()

  const hasWritePermission = hasPermission(user, Permission.MANUFACTURER_MODEL_WRITE)

  const handleRowClick = (manufacturerModelId?: string) => {
    navigate(`/${appId}/manufacturer-models/${manufacturerModelId}/view`, {
      state: { browserHistoryBack: true } as NavigateState,
    })
  }

  const handleCreateButtonClick = () => {
    navigate(`/${appId}/manufacturer-models/create`)
  }

  const createNewAction = (
    <ListingButton onClick={handleCreateButtonClick} variant="outlined" color="primary" startIcon={<Add />}>
      {translate('createNew')}
    </ListingButton>
  )

  const actions = hasWritePermission ? createNewAction : <></>

  return (
    <ScreenLayout title={translate('manufacturerModel')} actions={actions}>
      <ManufacturerModelTable navigateToItem={handleRowClick} />
    </ScreenLayout>
  )
}
